import chart from './chart'
import radar from './radar'
import title from './title'

export default {
    label: {
        innovationFields: 'Innovation fields',
        marketAnalysis: 'Market analysis',
        readiness: 'Readiness assessment',
        recommendations: 'Recommendation for action',
        innovationProjects: 'Innovation projects'
    },

    chart,
    radar,
    title
}
